import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheck = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 10,
	height: 10,
	viewBox: "0 0 10 10",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8.33329 2.5L3.74996 7.08333L1.66663 5",
		stroke: "white",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgCheck;
